module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" preserveAspectRatio=\"xMaxYMax meet\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#B8E986\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.67 7.99l2.64 2.2L11.94 6\"/><circle cx=\"8\" cy=\"8\" r=\"7.5\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/check-circle-green-chunky.svg
// module id = LC7+
// module chunks = 5